
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.005 1.852a3.44 3.44 0 00-4.511 0 2.24 2.24 0 01-1.312.543 3.44 3.44 0 00-3.19 3.19 2.24 2.24 0 01-.543 1.312 3.44 3.44 0 000 4.512c.318.366.51.827.543 1.311a3.44 3.44 0 003.19 3.19 2.24 2.24 0 011.312.544 3.44 3.44 0 004.511 0 2.24 2.24 0 011.312-.543 3.44 3.44 0 003.19-3.19 2.24 2.24 0 01.544-1.312 3.44 3.44 0 000-4.512 2.24 2.24 0 01-.544-1.312 3.44 3.44 0 00-3.19-3.19 2.24 2.24 0 01-1.312-.543z","stroke":"#545C69","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M9.656 8.85l2.437 2.438M15.843 7.539l-3.75 3.749","stroke":"#545C69","stroke-width":"1.2","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M10.976 17.104L8.06 22.151 6.66 19.323l-3.15.2 2.915-5.046M14.688 17.104l2.916 5.05 1.401-2.828 3.15.2-2.916-5.05","stroke":"#545C69","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    